/** @jsx jsx */
import React, { useState, useEffect } from 'react'
import { jsx, Grid, Flex, Box, Text } from 'theme-ui';
import { responsive } from '../../utils/helpers';
import { parseLineUps } from '../../api/opta'
import style from './style'

const LineUp = (props) => {

  const [teams, setTeams] = useState([])

  useEffect(() => {
    if (!props.data)
      return
    const lineups = parseLineUps(props.data)
    if (!lineups.success)
      return
    setTeams(lineups.data)
  }, [
    props.data,
    setTeams,
  ])

  const Coach = ({name, index}) => {
    return (
      <Flex sx={index === 0 ? style.reverse : style.text} mb={5}>
        <Player title='Coach' name={name} index={index} />
      </Flex>
    )
  }

  const Player = ({title, name, index}) => {
    return (
      <React.Fragment>
        <Text sx={style.bold} pr={index === 0 ? 0 : 1} pl={index === 0 ? 1 : 0}>{title}</Text>
        <Text>{name}</Text>
      </React.Fragment>
    )
  }

  const Players = ({players, index}) => {
    return (
      <Box>
        {players.map((x,i) => {
          return (
            <Flex sx={index === 0 ? style.reverse : style.text} key={i} mb={1}>
              <Player title={x.number} name={x.name} index={index} />
            </Flex>
          )
        })}
      </Box>
    )
  }

  const Subs = ({subs, index}) => {
    if (!subs)
      return null

    return (
      <React.Fragment>
        <Text pt={2} mb={1} sx={style.bold}>Substitutes</Text>
        <Flex sx={index === 0 ? style.reverse : style.text} mb={1}>
          {subs.map((x,i) => {
            return (
              <Text mr={'5px'} key={i}>{x.name}{((index === 0 && i === 0) || (index === 1 && i === subs.length - 1)) ? '' : ', '}</Text>
            )
          })}
        </Flex>
      </React.Fragment>
    )
  }

  const Team = ({index}) => {
    if (!(index in teams) || !teams[index])
      return null
    const x = teams[index];

    return (
      <React.Fragment>
        <Coach name={x.coach} index={index} />
        <Players players={x.players} index={index} />
        <Subs subs={x.substitutes} index={index} />
      </React.Fragment>
    )
  }

  const NotFound = () => {
    if (teams && teams.length > 1)
      return null
    return <Text sx={style.message}>Not available</Text>
  }

  return (
    <React.Fragment>
      <Grid columns={2}>
        <Flex sx={style.listOne}>
          <Team index={0} />
        </Flex>
        <Flex sx={style.listTwo}>
          <Team index={1} />
        </Flex>
      </Grid>
      <NotFound />
    </React.Fragment>
  )
}

export default LineUp
